import type React from 'react';
import { createContext, useContext, type ReactNode } from 'react';
import { useAuthenticate, type AuthenticateShape } from '@/services/api/auth/hooks/useAuthenticate';

const AuthContext = createContext<AuthenticateShape | null>(null);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const auth = useAuthenticate();

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

export const useAuthContext = (): AuthenticateShape => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within AuthProvider');
  }
  return context;
};
